<template>
  <div>
    <glide-component :settings="glideBasicOption" :active="selected">
      <!-- EACH SECION  -->
      <div
        :class="
          `cartegory-seven  ${index == currentTab ? 'item-seven-active' : ''}`
        "
        v-for="(section, index) in listSections"
        @click="selected = index"
        :key="`${index}_categorie`"
      >
        <img
          v-if="!classic"
          :src="
            `${
              section.image
                ? 'htttp://localhost:3333/uploads/categories/' +
                  section.image
                : 'htttp://localhost:3333/assets/img/detail-small-5.jpg'
            }`
          "
          alt=""
          class="category_img_seven"
        />
        <span class="category_title_seven" v-text="section.title">{{
          section.title
        }}</span>
      </div>
      <!-- END EACH SECTION  -->
    </glide-component>

    <template
      v-for="(subSection, indexSubCategorie) in listSections[selected]
        .sub_sections"
    >
      <div
        class="subsection-seven"
        :key="`${indexSubCategorie}_sub_categorie`"
        @click="
          sub_selected = indexSubCategorie;
          collapsedArray(indexSubCategorie, selected);
        "
        v-if="showSub(subSection)"
      >
        <span
          v-text="
            subSection.title == 'null-sub-sections' ? '' : subSection.title
          "
          >{{ subSection.title }}</span
        >
      </div>

      <template
        v-if="showSub(subSection) && vIfcollapsed(indexSubCategorie, selected)"
      >
        <div
          class="cartegory_item my_item_"
          v-for="(item, indiceItem) in subSection.items"
          @click="
            (e) => {
              addToCart(item, e);
            }
          "
          :key="`${indexSubCategorie}_${indiceItem}_mwnu_items`"
        >
          <div class="cartegory_item_content_seven">
            <div class="tags">
              <img
                :src="`htttp://localhost:3333/uploads/tags/${tag.image}`"
                v-for="(tag, indexTag) in item.tags"
                :key="`${indexSubCategorie}_${indiceItem}_${indexTag}_tag`"
              />

              <div class="tags_mask" v-if="item.tags"></div>
            </div>
            <img
              v-if="!classic"
              :src="
                `${
                  item.image
                    ? 'htttp://localhost:3333/uploads/menus-items/' +
                      item.image
                    : 'htttp://localhost:3333/assets/img/detail-small-5.jpg'
                }`
              "
              alt=""
              class="cartegory_item_img_seven"
            />
            <div class="cartegory_item_infos_seven ">
              <div
                class="d-flex"
                style="align-items: center;justify-content: space-between;"
              >
                <span class="cartegory_item_title_seven" v-text="item.title">{{
                  item.title
                }}</span>
                <div class="d-flex custom_price_seven">
                  <span
                    class="cartegory_item_price_seven"
                    v-text="item.price"
                    >{{ item.price }}</span
                  >
                  <span>{{ currentCurrency.symbol }}</span>
                </div>
              </div>
              <p v-text="item.observation">
                {{ item.observation }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import GlideComponent from "../plugins/GlideComponent.vue";

import draggable from "vuedraggable";
export default {
  components: {
    draggable,
    "glide-component": GlideComponent,
  },
  props: [
    "classic",
    "smaler",
    "newItem",
    "newSection",
    "listSections",
    "changeSectionTitle",
    "changeSectionSubTitle",
    "setCurrentTab",
    "currentTab",
    "addItem",
    "newSubSection",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "changeItemObservation",
    "changeItemPrice",
    "changeItemTitle",
    "editCategorie",
    "deleteSection",
    "editSubCategorie",
    "deleteSubSection",
    "editItem",
    "deleteItem",
    "currentCurrency",
    "functionCollapsed",
    "addToCart",
  ],
  data() {
    return {
      active: 0,
      collapsedArrayVar: [],
      glideBasicOption: {
        focusAt: 0,
        gap: 5,
        perView: 3,
        type: "carousel",
        hideNav: true,
        breakpoints: {
          600: {
            perView: 1,
          },
          1400: {
            perView: 2,
          },
        },
      },
      selected: 0,
      sub_selected: 0,
    };
  },
  watch: {
    selected(newval) {
   

      // this.$children[0].goTo(newval);
      // console.log(this.$children[0]);

      this.setCurrentTab(newval);
      // }
    },
    currentTab(newVal) {
      if (newVal != this.selected) {
        this.selected = newVal;
      }
    },
  },
  methods: {
    // goto() {
    // },
    vIfcollapsed(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;
      let item = this.collapsedArrayVar.find((item) => item == searchedIndice);
      if (item) {
        return true;
      } else {
        return false;
      }
    },
    collapsedArray(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;

      if (this.collapsedArrayVar.includes(searchedIndice)) {
        this.collapsedArrayVar.splice(
          this.collapsedArrayVar.indexOf(searchedIndice),
          1
        );
      } else {
        this.collapsedArrayVar.push(searchedIndice);
      }
    },
    collapsed(index, selected) {
      this.functionCollapsed(index, selected);
      // this.$emit("functionCollapsed", index, selected);
    },
    deleteCategorie() {
      let old_selected = this.selected;
      if (this.selected != 0) {
        this.selected = this.selected - 1;
      }
      this.deleteSection(old_selected);
    },
    showSub(subSection) {
      console.log(this.newItem[0].sections);
      console.log(subSection);
      console.log(this.listSections[this.selected].show_subCategories);
      if (this.listSections[this.selected].show_subCategories == undefined) {
        return true;
      }
      if (
        this.newItem[0].sections[this.selected].show_subCategories &&
        !subSection.defaultNonSub
      ) {
        return true;
      } else if (
        !this.newItem[0].sections[this.selected].show_subCategories &&
        subSection.defaultNonSub
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
@import url("../styles/sevenTheme/body.css");
</style>
